import React from "react";

const TelegramLogo = () => {
  return (
    <svg
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512 512"
    >
      <g>
        <circle
          cx="255.997"
          cy="256"
          r="255.997"
          fill="#41b4e6"
          data-original="#41b4e6"
        ></circle>
        <path
          d="M512 256.003c0-6.238-.235-12.419-.673-18.546L405.228 131.36 106.772 248.759l114.191 114.192 1.498 5.392 1.939-1.955.008.008-1.947 1.947L348.778 494.66C444.298 457.5 512 364.663 512 256.003"
          fill="#0091c8"
          data-original="#0091c8"
        ></path>
        <path
          d="m231.138 293.3 115.691 87.347 58.399-249.287-298.457 117.399 90.817 30.081 165.743-111.176z"
          fill="#ffffff"
          data-original="#ffffff"
          class=""
        ></path>
        <path
          d="m197.588 278.84 24.873 89.504 8.677-75.044 132.193-125.636z"
          fill="#d2d2d7"
          data-original="#d2d2d7"
          class=""
        ></path>
        <path
          d="m268.738 321.688-46.277 46.656 8.677-75.044z"
          fill="#b9b9be"
          data-original="#b9b9be"
        ></path>
      </g>
    </svg>
  );
};

export default TelegramLogo;
